<template>
  <component v-if="ldJson" :is="'script'" type="application/ld+json" v-text="ldJson" data-gmf></component>
</template>

<script>
import state from '@/state';

function findStructuredDataLdJson(type = 'Product', useIdHack = true) {
  const rawTags = [...document.querySelectorAll('script[type="application/ld+json"]')].filter(
    (e) => !e.hasAttribute('data-gmf')
  );

  for (const el of rawTags) {
    try {
      const data = JSON.parse(el.innerText);
      const arrData = Array.isArray(data) ? data : [data];

      for (const b of arrData) {
        if (b['@type'] === type) {
          if (!b['@id'] && useIdHack) {
            // Apply ID hack
            b['@id'] = `#${type.toLowerCase()}`;
            // Update the script tag content
            el.innerText = JSON.stringify(data);
          }
          return b['@id'];
        }
      }
    } catch (e) {
      console.error('Error parsing ld+json', e);
    }
  }

  return null; // No matching data found
}

function findStructuredDataMicrodata(type = 'Product', useIdHack = true) {
  if (!type) {
    throw new Error('type is required');
  }

  const rawItems = [...document.querySelectorAll(`[itemscope][itemtype$="/${type}"]`)].filter(
    (el) => !el.hasAttribute('data-gmf')
  );

  for (const el of rawItems) {
    try {
      let id = el.getAttribute('itemid');

      if (!id && useIdHack) {
        // Apply ID hack
        id = `#${type.toLowerCase()}`;
        el.setAttribute('itemid', id);
      }

      return id;
    } catch (e) {
      console.error('Error parsing microdata', e);
    }
  }

  return null; // No matching data found
}

function findExistingId(type, useIdHack = true) {
  const idFromLdJson = findStructuredDataLdJson(type, useIdHack);
  if (idFromLdJson) {
    return idFromLdJson;
  }

  const idFromMicrodata = findStructuredDataMicrodata(type, useIdHack);
  return idFromMicrodata;
}

export default {
  props: ['ratingSummaries', 'comments', 'product'],
  computed: {
    ldJson () {
      if (! this.ratingSummaries) {
        return null;
      }

      const useIdHack = !! state.merchantConfig?.structuredDataIdHack;
      const existingId = findExistingId('Product', useIdHack);
      const data = {
        '@id': existingId || '#product',
        '@context': 'http://schema.org',
        '@type': 'Product',
      };

      if (state.merchantConfig?.structuredData?.includeProductData && this.product) {
        data.name = this.product.name;
      }

      const rs = this.ratingSummaries;
      if (rs && rs.product_score) {
        data.aggregateRating = {
          '@type': 'AggregateRating',
          'ratingValue': rs.product_score.ratingAverage.toFixed(1),
          'reviewCount': parseInt(rs.product_score.ratingCount),
        };
      } else {
        return null;
      }

      return JSON.stringify(data);
    },
  },
};
</script>
